class AssociatedFilesDto {
  /** 附件名称 */
  fileName = "";

  /** 附件地址 */
  fileUrl = "";
}

class AssociatedFilesResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 文件类型 */
  fileCategory = "";

  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 来源标识 */
  sourceId = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CelebrityApprovalRelationResponseDto {
  /** 当前审核步骤 */
  currentApprovalStatus = "";

  /** KOL编码 */
  kolno = "";

  /** 领用编码 */
  lyno = "";

  /** 用户姓名 */
  userName = "";

  /** 用户编号 */
  userNo = "";

  /** user:使用人,initiator:发起人,approver:审批人 */
  userType = "";
}

class CelebrityCategoryRelationRequestDto {
  /** KOL分类编码 */
  kolCategoryCode = "";

  /** KOL分类名称 */
  kolCategoryName = "";

  /** KOL编码 */
  kolno = "";
}

class CelebrityCategoryRelationResponseDto {
  /** id */
  id = undefined;

  /** KOL分类 */
  kolCategoryCode = "";

  /** KOL分类名称 */
  kolCategoryName = "";

  /** KOL编码 */
  kolno = "";
}

class CelebrityDeliveryAddressRequestDto {
  /** 收货地址 */
  address = "";

  /** 区代码 */
  areaCode = "";

  /** 区中文名称 */
  areaNameCn = "";

  /** 城市代码 */
  cityCode = "";

  /** 城市中文名称 */
  cityNameCn = "";

  /** 国家中文名称 */
  countryNameCn = "";

  /** KOL编码 */
  kolno = "";

  /** 邮编 */
  postCode = "";

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 中文名称 */
  stateNameCn = "";
}

class CelebrityDeliveryAddressResponseDto {
  /** 收货地址 */
  address = "";

  /** 区代码 */
  areaCode = "";

  /** 区中文名称 */
  areaNameCn = "";

  /** 城市代码 */
  cityCode = "";

  /** 城市中文名称 */
  cityNameCn = "";

  /** 国家中文名称 */
  countryNameCn = "";

  /** id */
  id = undefined;

  /** KOL编码 */
  kolno = "";

  /** 邮编 */
  postCode = "";

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 中文名称 */
  stateNameCn = "";
}

class CelebrityLanguageRelationRequestDto {
  /** KOL编码 */
  kolno = "";

  /** 语言编码 */
  languageCode = "";

  /** 语言名称 */
  languageName = "";
}

class CelebrityLanguageRelationResponseDto {
  /** id */
  id = undefined;

  /** KOL编码 */
  kolno = "";

  /** 语言编码 */
  languageCode = "";

  /** 语言名称 */
  languageName = "";
}

class CelebrityLinkRequestDto {
  /** KOL链接 */
  kolLink = "";

  /** KOL编码 */
  kolno = "";
}

class CelebrityLinkResponseDto {
  /** id */
  id = undefined;

  /** KOL链接 */
  kolLink = "";

  /** KOL编码 */
  kolno = "";
}

class CelebrityPaymentAccountRequestDto {
  /** 收款账号名称 */
  accountName = "";

  /** 收款银行账号 */
  bankAccount = "";

  /** 收款银行名称 */
  bankName = "";

  /** KOL编码 */
  kolno = "";
}

class CelebrityPaymentAccountResponseDto {
  /** 收款账号名称 */
  accountName = "";

  /** 收款银行账号 */
  bankAccount = "";

  /** 收款银行名称 */
  bankName = "";

  /** id */
  id = undefined;

  /** KOL编码 */
  kolno = "";
}

class CelebrityRequestDto {
  /** KOL分类 */
  celebrityCategory = [];

  /** 收货地址 */
  celebrityDeliveryAddress = [];

  /** 语言选项 */
  celebrityLanguage = [];

  /** KOL链接 */
  celebrityLink = [];

  /** 收款信息 */
  celebrityPaymentAccount = [];

  /** 渠道名称 */
  channelName = "";

  /** code码 */
  code = "";

  /** 合作关系:true=合作启用 */
  cooperationStatus = false;

  /** 国家中文名称 */
  countryNameCn = "";

  /** 国家二字码 */
  countrySecondWord = "";

  /** 粉丝受众 */
  fansAudience = "";

  /** 粉丝数 */
  fansCount = undefined;

  /** 性别，0：男，1：女，-1：中性 */
  gender = undefined;

  /** id */
  id = undefined;

  /** KOL生日 */
  kolBirthday = "";

  /** KOL渠道编号 */
  kolChannelCode = "";

  /** KOL渠道名称 */
  kolChannelName = "";

  /** KOL邮箱 */
  kolEmail = "";

  /** KOL姓名 */
  kolName = "";

  /** KOL编码 */
  kolno = "";

  /** 其他联系方式 */
  otherContact = "";

  /** 支付方式编码 */
  payTypeCode = "";

  /** 支付方式名称 */
  payTypeName = "";

  /** 负责人用户姓名 */
  principalUserName = "";

  /** 负责人用户编码 */
  principalUserNo = "";

  /** 备注 */
  remark = "";

  /** 使用状态 */
  useStatus = "";
}

class CelebrityResponseDto {
  /** 审核状态 */
  approvalStatus = "";

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** KOL分类 */
  celebrityCategory = [];

  /** 收货地址 */
  celebrityDeliveryAddress = [];

  /** 语言选项 */
  celebrityLanguage = [];

  /** KOL链接 */
  celebrityLink = [];

  /** 收款信息 */
  celebrityPaymentAccount = [];

  /** 渠道名称 */
  channelName = "";

  /** code码 */
  code = "";

  /** 合作关系:0=合作启用 */
  cooperationStatus = false;

  /** 国家中文名称 */
  countryNameCn = "";

  /** 国家二字码 */
  countrySecondWord = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createName = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前负责人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 删除标识 */
  deleted = undefined;

  /** 粉丝受众 */
  fansAudience = "";

  /** 粉丝数 */
  fansCount = undefined;

  /** 性别，0：男，1：女，-1：中性 */
  gender = undefined;

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 工作流实例ID */
  instanceId = "";

  /** KOL生日 */
  kolBirthday = "";

  /** KOL渠道编号 */
  kolChannelCode = "";

  /** KOL渠道名称 */
  kolChannelName = "";

  /** KOL邮箱 */
  kolEmail = "";

  /** KOL姓名 */
  kolName = "";

  /** KOL编码 */
  kolno = "";

  /** 版本 */
  lockVersion = undefined;

  /** 其他联系方式 */
  otherContact = "";

  /** 支付方式编码 */
  payTypeCode = "";

  /** 支付方式名称 */
  payTypeName = "";

  /** 负责人用户姓名 */
  principalUserName = "";

  /** 负责人用户编码 */
  principalUserNo = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回人 */
  rejector = "";

  /** 备注 */
  remark = "";

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateName = "";

  /** 修改时间 */
  updateTime = "";

  /** 使用状态 */
  useStatus = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new CelebrityResponseDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class UseCelebrityCategoryRelationRequestDto {
  /** KOL分类 */
  kolCategoryCode = "";

  /** KOL分类名称 */
  kolCategoryName = "";

  /** KOL编码 */
  kolno = "";
}

class UseCelebrityCategoryRelationResponseDto {
  /** id */
  id = undefined;

  /** KOL分类 */
  kolCategoryCode = "";

  /** KOL分类名称 */
  kolCategoryName = "";

  /** KOL编码 */
  kolno = "";

  /** 领用编码 */
  lyno = "";
}

class UseCelebrityDeliveryAddressRequestDto {
  /** 收货地址 */
  address = "";

  /** 区代码 */
  areaCode = "";

  /** 区中文名称 */
  areaNameCn = "";

  /** 城市代码 */
  cityCode = "";

  /** 城市中文名称 */
  cityNameCn = "";

  /** 国家中文名称 */
  countryNameCn = "";

  /** KOL编码 */
  kolno = "";

  /** 邮编 */
  postCode = "";

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 中文名称 */
  stateNameCn = "";
}

class UseCelebrityDeliveryAddressResponseDto {
  /** 收货地址 */
  address = "";

  /** 区代码 */
  areaCode = "";

  /** 区中文名称 */
  areaNameCn = "";

  /** 城市代码 */
  cityCode = "";

  /** 城市中文名称 */
  cityNameCn = "";

  /** 国家中文名称 */
  countryNameCn = "";

  /** id */
  id = undefined;

  /** KOL编码 */
  kolno = "";

  /** 领用编码 */
  lyno = "";

  /** 邮编 */
  postCode = "";

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 中文名称 */
  stateNameCn = "";
}

class UseCelebrityLanguageRelationRequestDto {
  /** KOL编码 */
  kolno = "";

  /** 语言编码 */
  languageCode = "";

  /** 语言名称 */
  languageName = "";
}

class UseCelebrityLanguageRelationResponseDto {
  /** id */
  id = undefined;

  /** KOL编码 */
  kolno = "";

  /** 语言编码 */
  languageCode = "";

  /** 语言名称 */
  languageName = "";

  /** 领用编码 */
  lyno = "";
}

class UseCelebrityLinkRequestDto {
  /** KOL链接 */
  kolLink = "";

  /** KOL编码 */
  kolno = "";
}

class UseCelebrityLinkResponseDto {
  /** id */
  id = undefined;

  /** KOL链接 */
  kolLink = "";

  /** KOL编码 */
  kolno = "";

  /** 领用编码 */
  lyno = "";
}

class UseCelebrityPaymentAccountRequestDto {
  /** 收款账号名称 */
  accountName = "";

  /** 收款银行账号 */
  bankAccount = "";

  /** 收款银行名称 */
  bankName = "";

  /** KOL编码 */
  kolno = "";
}

class UseCelebrityPaymentAccountResponseDto {
  /** 收款账号名称 */
  accountName = "";

  /** 收款银行账号 */
  bankAccount = "";

  /** 收款银行名称 */
  bankName = "";

  /** id */
  id = undefined;

  /** KOL编码 */
  kolno = "";

  /** 领用编码 */
  lyno = "";
}

class UseCelebrityRequestDto {
  /** KOL分类 */
  celebrityCategory = [];

  /** 收货地址 */
  celebrityDeliveryAddress = [];

  /** 语言选项 */
  celebrityLanguage = [];

  /** KOL链接 */
  celebrityLink = [];

  /** 账号信息 */
  celebrityPaymentAccount = [];

  /** 渠道名称 */
  channelName = "";

  /** code码 */
  code = "";

  /** 合作关系:0=合作启用 */
  cooperationStatus = false;

  /** 国家中文名称 */
  countryNameCn = "";

  /** 国家二字码 */
  countrySecondWord = "";

  /** 粉丝受众 */
  fansAudience = "";

  /** 粉丝数 */
  fansCount = undefined;

  /** 附件 */
  files = [];

  /** 性别，0：男，1：女，-1：中性 */
  gender = undefined;

  /** id */
  id = undefined;

  /** KOL生日 */
  kolBirthday = "";

  /** KOL渠道编号 */
  kolChannelCode = "";

  /** KOL渠道名称 */
  kolChannelName = "";

  /** KOL邮箱 */
  kolEmail = "";

  /** KOL姓名 */
  kolName = "";

  /** KOL编码 */
  kolno = "";

  /** 领用编码 */
  lyno = "";

  /** 其他联系方式 */
  otherContact = "";

  /** 支付方式编码 */
  payTypeCode = "";

  /** 支付方式名称 */
  payTypeName = "";

  /** 负责人用户姓名 */
  principalUserName = "";

  /** 负责人用户编码 */
  principalUserNo = "";

  /** 备注 */
  remark = "";

  /** 正式使用时间 */
  useBeginTime = "";

  /** 申请领用时长(天) */
  useDuration = undefined;

  /** 领用结束时间 */
  useEndTime = "";

  /** 使用状态 */
  useStatus = "";

  /** 领用人编码 */
  useUserCode = "";

  /** 领用人姓名 */
  useUserName = "";
}

class UseCelebrityResponseDto {
  /** 审核状态 */
  approvalStatus = "";

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** KOL分类 */
  celebrityCategory = [];

  /** 收货地址 */
  celebrityDeliveryAddress = [];

  /** 语言选项 */
  celebrityLanguage = [];

  /** KOL链接 */
  celebrityLink = [];

  /** 收款信息 */
  celebrityPaymentAccount = [];

  /** 渠道名称 */
  channelName = "";

  /** code码 */
  code = "";

  /** 合作关系:0=合作启用 */
  cooperationStatus = false;

  /** 国家中文名称 */
  countryNameCn = "";

  /** 国家二字码 */
  countrySecondWord = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createName = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前负责人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否提前结束 */
  endFlag = false;

  /** 粉丝受众 */
  fansAudience = "";

  /** 粉丝数 */
  fansCount = undefined;

  /** 附件 */
  files = [];

  /** 性别，0：男，1：女，-1：中性 */
  gender = undefined;

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 发起人姓名 */
  initiatorName = "";

  /** 工作流实例ID */
  instanceId = "";

  /** KOL生日 */
  kolBirthday = "";

  /** KOL渠道编号 */
  kolChannelCode = "";

  /** KOL渠道名称 */
  kolChannelName = "";

  /** KOL邮箱 */
  kolEmail = "";

  /** KOL姓名 */
  kolName = "";

  /** KOL编码 */
  kolno = "";

  /** 版本 */
  lockVersion = undefined;

  /** 领用编码 */
  lyno = "";

  /** 单据可操作人 */
  orderOperator = [];

  /** 其他联系方式 */
  otherContact = "";

  /** 支付方式编码 */
  payTypeCode = "";

  /** 支付方式名称 */
  payTypeName = "";

  /** 负责人用户姓名 */
  principalUserName = "";

  /** 负责人用户编码 */
  principalUserNo = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回人 */
  rejector = "";

  /** 备注 */
  remark = "";

  /** 剩余领用时长 */
  residueDuration = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateName = "";

  /** 修改时间 */
  updateTime = "";

  /** 正式使用时间 */
  useBeginTime = "";

  /** 申请领用时长(天) */
  useDuration = undefined;

  /** 领用结束时间 */
  useEndTime = "";

  /** 使用状态 */
  useStatus = "";

  /** 领用人编码 */
  useUserCode = "";

  /** 领用人姓名 */
  useUserName = "";
}

class UserCelebrityApprovalRequestDto {
  /** 审批结果 approved=通过；rejected=驳回 */
  approvalStatus = "";

  /** lyno */
  lyno = "";

  /** 驳回备注 */
  rejectRemark = "";
}

class UserCelebrityEndOfUseRequestDto {
  /** lyno */
  lyno = "";

  /** 备注 */
  remark = "";
}

class UserCelebrityTransferRequestDto {
  /** lyno */
  lyno = "";

  /** 接收人用户编号 */
  userCode = "";

  /** 接收人用户名称 */
  userName = "";
}

export const kol = {
  AssociatedFilesDto,
  AssociatedFilesResponseDto,
  CelebrityApprovalRelationResponseDto,
  CelebrityCategoryRelationRequestDto,
  CelebrityCategoryRelationResponseDto,
  CelebrityDeliveryAddressRequestDto,
  CelebrityDeliveryAddressResponseDto,
  CelebrityLanguageRelationRequestDto,
  CelebrityLanguageRelationResponseDto,
  CelebrityLinkRequestDto,
  CelebrityLinkResponseDto,
  CelebrityPaymentAccountRequestDto,
  CelebrityPaymentAccountResponseDto,
  CelebrityRequestDto,
  CelebrityResponseDto,
  IPage,
  Response,
  ResponseDto,
  UseCelebrityCategoryRelationRequestDto,
  UseCelebrityCategoryRelationResponseDto,
  UseCelebrityDeliveryAddressRequestDto,
  UseCelebrityDeliveryAddressResponseDto,
  UseCelebrityLanguageRelationRequestDto,
  UseCelebrityLanguageRelationResponseDto,
  UseCelebrityLinkRequestDto,
  UseCelebrityLinkResponseDto,
  UseCelebrityPaymentAccountRequestDto,
  UseCelebrityPaymentAccountResponseDto,
  UseCelebrityRequestDto,
  UseCelebrityResponseDto,
  UserCelebrityApprovalRequestDto,
  UserCelebrityEndOfUseRequestDto,
  UserCelebrityTransferRequestDto,
};
